import React, { ReactNode } from "react";

import { CardsGridSectionContainer } from "./styles";
import { CardGrid, CardGridSkeleton } from "../../components/Card/CardGrid";
import { CardProps } from "../../components/Card/types";
import { SectionTitle } from "../../components/SectionTitle";
import { SimpleLinkProps } from "@itchannelplus/utils";
import { ButtonLink } from "../../components/buttons/Button";

export type CardsGridSectionProps = {
  title?: string;
  tagline?: string;
  cards: CardProps[];
  cols?: 2 | 3 | 4 | 5;
  alignCards?: "left" | "center" | "right";
  cta?: SimpleLinkProps;
  children?: ReactNode;
};
/*
      const cards = destinations.map( destination => {
            return {image: destination.image, title:destination.name, caption: name}
          });
 */
export const CardsGridSection = ({
  title,
  tagline,
  cards,
  cols,
  cta,
  alignCards,
  children,
}: CardsGridSectionProps) => {
  //const [filteredGroups, setFilteredGroups] = useState(groups);
  //const subsetCards = expandable ? cards.slice(0, cols) : cards;

  return (
    <CardsGridSectionContainer>
      {title && <SectionTitle tagline={tagline}>{title}</SectionTitle>}
      <CardGrid cards={cards} cols={cols} align={alignCards} />
      {cta && (
        <ButtonLink
          href={cta.href}
          label={cta.label}
          target={cta.target}
          margin={"topMedium"}
          center
          size={"normal"}
          width={"content"}
        />
      )}
      {children}
    </CardsGridSectionContainer>
  );
};

export const CardsGridSkeletonSection = ({
  cols = 4,
  imageRatio = "3/4",
  hideTitle,
}: Pick<CardsGridSectionProps, "cols"> &
  Partial<Pick<CardProps, "imageRatio">> & { hideTitle?: boolean }) => {
  return (
    <CardsGridSectionContainer>
      {!hideTitle && (
        <SectionTitle className={"skeleton skeleton-title"}>
          &nbsp;
        </SectionTitle>
      )}
      <CardGridSkeleton cols={cols} imageRatio={imageRatio} />
    </CardsGridSectionContainer>
  );
};

export default CardsGridSection;
